import { DndAppActionType } from '../actiontype/dnd-app.actiontype';
import Page from '../constants/page.enum';

const initialState = {
    userPreference: '',
    activePage: Page.HOME_PAGE
    // activePage: Page.REGISTRATION_FORM
};

export default function dndAppReducer(state = initialState, action) {
    switch (action.type) {
        case DndAppActionType.USERPREFERENCE:
        return {
            ...state,
            userPreference: action.payload
        }
        case DndAppActionType.OPEN_PAGE:
        return {
            ...state,
            activePage: action.payload
        }
        default:
        return state;
    }
}